<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>团体赛赛务管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 团体赛赛程 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">团体赛赛程</span>
        </el-col>
      </el-row>
      <el-row :gutter="30">
        <div v-for="(item, index) in scheduleCardList" v-bind:key="index">
          <el-col :span="5">
            <el-card
              shadow="hover"
              style="border:none;"
              :class="'card-background' + (index+1)"
            >
              <div class="schedule_card" @click="scheduleCardTap(item)">
                <div class="schedule_gameName">{{ item.scheduleName }}</div>
                <div class="schedule_gameNumber">
                  {{ item.descStr }}
                </div>
              </div>
            </el-card>
          </el-col>
        </div>
      </el-row>
    </el-card>
    <!-- 团体赛赛务工具 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">团体赛赛务工具</span>
        </el-col>
      </el-row>
      <el-row :gutter="30" style="margin-top: 34px;">
        <el-col :span="4" v-for="(item, i) of racingToolList" v-bind:key="i">
          <div
            class="racing-tool-back"
            @click="racingToolClicked(item.menuTag)"
          >
            <!-- <el-image
              class="racing-tool-leftimg"
              :src="item.leftImg"
              fit="contain"
            ></el-image> -->
            <div class="racing-tool-leftimg" :class="'coloricon' + item.menuTag">
              <i class="icon iconfont" :class="item.icon"></i>
            </div>
            <div class="racing-tool-right">
              <div>{{ item.rightTitle }}</div>
              <div class="racing-tool-desc">{{ item.rightDesc }}</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-row :gutter="16">
      <el-col :span="12">
        <!-- 待处理事务 -->
        <el-card style="margin-top: 15px">
          <el-row class="title_row">
            <el-col>
              <span class="title_class">待处理事务</span>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="6" v-for="(item, i) of processedList" v-bind:key="i">
              <div class="processed-list-con">
                <!-- <el-image
                  class="processed-image"
                  :src="item.iconImg"
                  fit="contain"
                ></el-image> -->
                <div class="processed-image" :class="'coloricon'+(i+1)"><i class="icon iconfont" :class="item.icon"></i></div>
                <div>
                  <div class="processed-desc">{{ item.number }}</div>
                  <div class="processed-title">{{ item.title }}</div>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card style="margin-top: 15px">
          <el-row class="title_row">
            <el-col>
              <span class="title_class">数据统计</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6" v-for="(item, i) of dataStatisticsLost" v-bind:key="i">
              <div class="processed-list-back" @click="racingToolClicked(item.menuTag)">
                <div class="dataStatistics-desc">{{ item.rightDesc }}</div>
                <div class="dataStatistics-title">{{ item.rightTitle }}</div>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <!-- 数据统计 -->
    <el-card style="margin-top: 15px">
      <el-row style="margin: 0 auto 30px; font-size: 16px">
        <el-col>
          <span class="title_class">实时报名情况</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div class="item-sign-backview">
            <div class="item-sign-data">
              <div
                class="item-sign-data-child"
                v-for="(item, index) in signInListData"
                v-bind:key="index"
              >
                <div class="child-data-title">{{ item.titleStr }}</div>
                <div class="child-data-number">{{ item.descStr }}</div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="item-sign-backview"></div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      scheduleCardList: [
        {
          scheduleName: '俱乐部管理',
          scheduleId: '1',
          promotionNum: 0,
          backGround: '#57a3f7',
          descStr: '查看已注册俱乐部',
          flag: this.$chnEngStatusCode.INDIVIDUAL_PRELIMINARY
        }, {
          scheduleName: '区域赛',
          scheduleId: '2',
          promotionNum: 0,
          descStr: '参加半决选战队',
          backGround: '#fb6260',
          flag: this.$chnEngStatusCode.NATIONAL_FINALS
        }, {
          scheduleName: '全国总决赛',
          scheduleId: '3',
          promotionNum: 0,
          descStr: '参加总决选战队',
          backGround: '#8167f5',
          flag: this.$chnEngStatusCode.NATIONAL_FINALS
        }
      ],
      racingToolList: [
        {
          // leftImg: require('@/assets/img/icon-shijuanguanli.png'),
          icon: 'icon-tuandui',
          rightTitle: '战队管理',
          rightDesc: '战队VS战队',
          menuTag: '1'
        },
        {
          // leftImg: require('@/assets/img/icon-youhuiquan.png'),
          icon: 'icon-rili',
          rightTitle: '比赛时间管理',
          rightDesc: '修改赛区/学校比赛时间',
          menuTag: '2'
        },
        {
          // leftImg: require('@/assets/img/icon-rili.png'),
          icon: 'icon-tongzhi',
          rightTitle: '比赛通知管理',
          rightDesc: '新增/修改比赛通知',
          menuTag: '3'
        },
        {
          // leftImg: require('@/assets/img/icon-school.png'),
          icon: 'icon-house-full',
          rightTitle: '区域赛考场管理',
          rightDesc: '新增/修改考场信息',
          menuTag: '4'
        }
      ],
      processedList: [
        {
          // iconImg: require('@/assets/img/icon-school.png'),
          icon: 'icon-user',
          title: '待缴费选手',
          number: 0
        },
        {
          // iconImg: require('@/assets/img/icon-shijuanguanli.png'),
          icon: 'icon-tuandui',
          title: '待缴费战队',
          number: 0
        },
        {
          // iconImg: require('@/assets/img/icon-waitsend.png'),
          icon: 'icon-fahuo2',
          title: '待发货订单',
          number: 0
        },
        // {
        //   iconImg: require('@/assets/img/icon-waitReceive.png'),
        //   title: '已发货订单',
        //   number: '10'
        // },
        {
          // iconImg: require('@/assets/img/icon-waitSite.png'),
          icon: 'icon-tuikuanguanli',
          title: '待处理退款申请',
          number: 0
        }
      ],
      dataStatisticsLost: [
        {
          leftImg: require('@/assets/img/icon-shijuanguanli.png'),
          rightTitle: '已注册战队',
          rightDesc: 0,
          menuTag: '1'
        },
        {
          leftImg: require('@/assets/img/icon-youhuiquan.png'),
          rightTitle: '已缴费战队',
          rightDesc: 0,
          menuTag: '2'
        },
        {
          leftImg: require('@/assets/img/icon-rili.png'),
          rightTitle: '已参与学校',
          rightDesc: 0,
          menuTag: '3'
        },
        {
          leftImg: require('@/assets/img/icon-school.png'),
          rightTitle: '已缴费选手',
          rightDesc: 0,
          menuTag: '4'
        }
        // {
        //   leftImg: require('@/assets/img/icon-school.png'),
        //   rightTitle: '未缴费选手',
        //   rightDesc: '100',
        //   menuTag: '5'
        // }
      ],
      signInListData: [
        {
          titleStr: '今日缴费总额',
          descStr: 0
        },
        {
          titleStr: '销售目标完成率',
          descStr: '0%'
        },
        {
          titleStr: '报名剩余时间',
          descStr: '00:00:00'
        }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.schedule_card {
  width: 100%;
  height: 54px;
  border-radius: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
}
.schedule_gameName {
  text-align: left;
  color: white;
  font-size: 20px;
  margin-bottom: 6px;
}

.schedule_gameNumber {
  text-align: left;
  color: white;
  font-size: 12px;
}
.item-sign-backview {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.item-sign-data {
  width: 100%;
  display: flex;
  flex-direction: row;
}
.item-sign-data-child {
  width: 33%;
  display: flex;
  flex-direction: column;
}

</style>
